import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './myLearning.module.css';
import Header from '../../components/standartComponents/header';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const MyLearning = ({ authUser }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [videoTab, setVideoTab] = useState('all');

  // Use personal user videos from authUser (fetched at login via checkAuthStatus)
  const userVideosAll = authUser?.videoLessonsAll || [];
  const userVideosStarted = authUser?.videoLessonsStarted || [];
  const userVideosCompleted = authUser?.videoLessonsCompleted || [];

  // If no personal videos, redirect to survey
  if (userVideosAll.length === 0 && authUser?.isAuthenticated) {
    navigate('/survey');
    return null;
  }

  const currentVideos = videoTab === 'started' ? userVideosStarted
    : videoTab === 'completed' ? userVideosCompleted
    : userVideosAll;

  // Find last started video for "Continue" section
  const lastVideo = userVideosStarted[0] || userVideosAll[0] || null;

  const handleRemoveVideo = async (id) => {
    try {
      await axios.delete(`/api/v1/student/video-lessons/${id}/`, { withCredentials: true });
      // Remove from local state by reloading the page
      window.location.reload();
    } catch (err) {
      console.error('Error removing video:', err);
    }
  };

  return (
    <>
      <Header authUser={authUser} />
      
      <div className={classes.page}>
        {/* WELCOME */}
        <div className={classes.welcome}>
          <h1>З поверненням, {authUser?.user?.first_name || authUser?.name || 'Студенте'}! 👋</h1>
          <p>Продовжуйте самостійне навчання з того місця, де зупинилися.</p>
        </div>

        {/* CONTINUE */}
        {lastVideo ? (
          <div className={classes.cont}>
            <div className={classes.contLeft}>
              <div className={classes.contIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              </div>
              <div>
                <div className={classes.contLabel}>Продовжити навчання</div>
                <div className={classes.contTitle}>{lastVideo.video?.name || lastVideo.video_lesson_name || 'Урок'}</div>
                <div className={classes.contStep}>{lastVideo.completion_percentage || 0}% пройдено</div>
              </div>
            </div>
            <div className={classes.contRight}>
              <button className={`${classes.contBtn} ${classes.cbP}`} onClick={() => navigate(`/lesson/${lastVideo.video_lesson || lastVideo.id}`)}>
                Продовжити <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
              <button className={`${classes.contBtn} ${classes.cbS}`} onClick={() => navigate('/allvideos')}>Усі відео</button>
            </div>
          </div>
        ) : (
          <div className={classes.cont}>
            <div className={classes.contLeft}>
              <div className={classes.contIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              </div>
              <div>
                <div className={classes.contLabel}>Почніть навчання</div>
                <div className={classes.contTitle}>Оберіть перший урок</div>
                <div className={classes.contStep}>Перегляньте каталог відео та оберіть тему</div>
              </div>
            </div>
            <div className={classes.contRight}>
              <button className={`${classes.contBtn} ${classes.cbP}`} onClick={() => navigate('/allvideos')}>
                Перейти до відео <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
            </div>
          </div>
        )}

        {/* STATS */}
        <div className={classes.stats}>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si1}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            </div>
            <div className={classes.statVal}>{userVideosStarted.length}</div>
            <div className={classes.statLbl}>відео в процесі</div>
          </div>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si2}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <div className={classes.statVal}>{userVideosCompleted.length}</div>
            <div className={classes.statLbl}>завершено</div>
          </div>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si3}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>
            </div>
            <div className={classes.statVal}>{userVideosAll.length}</div>
            <div className={classes.statLbl}>моїх відео</div>
          </div>
          <div className={classes.stat}>
            <div className={`${classes.statIcon} ${classes.si4}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>
            </div>
            <div className={classes.statVal}>{authUser?.stats?.streak_days || 0}</div>
            <div className={classes.statLbl}>днів підряд</div>
          </div>
        </div>

        {/* COURSES SECTION */}
        <div className={classes.sec}>
          <div className={classes.secHead}>
            <div className={classes.secTitle}>Мої курси</div>
          </div>
          <div className={classes.secSub}>Персональні навчальні плани з прогресом по рівню.</div>
          
          <div className={classes.courseRec} style={{gridTemplateColumns: '1fr'}}>
            <div className={classes.crCard} onClick={() => navigate('/create-course')} style={{maxWidth: '380px'}}>
              <div className={classes.crBadge}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z"/></svg>Рекомендовано
              </div>
              <div className={classes.crIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
              </div>
              <div className={classes.crTitle}>Хочете більше структури?</div>
              <div className={classes.crDesc}>Персональний план допоможе проходити уроки у правильному порядку та бачити прогрес по рівню.</div>
              <button className={`${classes.crBtn} ${classes.crBtnP}`} onClick={(e) => { e.stopPropagation(); navigate('/create-course'); }}>
                Створити план <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
              <div className={classes.crNote}>Самостійне навчання залишиться доступним.</div>
            </div>
          </div>
        </div>

        {/* MY VIDEOS */}
        <div className={classes.sec}>
          <div className={classes.secHead}>
            <div className={classes.secTitle}>Мої відео</div>
            <Link to="/allvideos" className={classes.secLink}>Перейти до всіх відео <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></Link>
          </div>
          <div className={classes.secSub}>Відео, які ви додали до свого кабінету.</div>

          <div className={classes.vtabs}>
            <button className={`${classes.vtab} ${videoTab === 'all' ? classes.on : ''}`} onClick={() => setVideoTab('all')}>
              Усі <span className={classes.vtabCount}>{userVideosAll.length}</span>
            </button>
            <button className={`${classes.vtab} ${videoTab === 'started' ? classes.on : ''}`} onClick={() => setVideoTab('started')}>
              У процесі <span className={classes.vtabCount}>{userVideosStarted.length}</span>
            </button>
            <button className={`${classes.vtab} ${videoTab === 'completed' ? classes.on : ''}`} onClick={() => setVideoTab('completed')}>
              Завершені <span className={classes.vtabCount}>{userVideosCompleted.length}</span>
            </button>
          </div>

          {currentVideos.length === 0 ? (
            <div style={{textAlign: 'center', padding: '40px', color: '#8E89A3'}}>
              {videoTab === 'started' ? 'Немає відео в процесі' : videoTab === 'completed' ? 'Немає завершених відео' : 'Немає доданих відео'}
            </div>
          ) : (
            <div className={classes.vgrid}>
              {currentVideos.map(v => {
                const thumbnail = v.video?.thumbnail || v.thumbnail;
                const videoName = v.video?.name || v.video_lesson_name || 'Урок';
                const videoId = v.video_lesson || v.id;
                return (
                  <div key={v.id} className={classes.vc} onClick={() => navigate(`/lesson/${videoId}`)}>
                    <div className={classes.vcThumb} style={{background: thumbnail ? `url(${thumbnail}) center/cover` : 'linear-gradient(135deg, #0F0B2E, #1A1145, #2D1B69)'}}>
                      {v.level_name && <div className={classes.vcLevel}>{v.level_name}</div>}
                      {v.category_name && <div className={classes.vcTopic}>{v.category_name}</div>}
                    </div>
                    <div className={classes.vcBody}>
                      <div className={classes.vcTitle}>{videoName}</div>
                      <div className={classes.vcBottom}>
                        <button className={`${classes.contBtn} ${classes.cbP}`} onClick={(e) => { e.stopPropagation(); navigate(`/lesson/${videoId}`); }} style={{padding: '6px 14px', fontSize: '12px'}}>
                          Почати <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:'14px',height:'14px'}}><polygon points="5 3 19 12 5 21 5 3"/></svg>
                        </button>
                        <button className={classes.vcRemove} onClick={(e) => { e.stopPropagation(); handleRemoveVideo(v.id); }} title="Видалити з моїх відео">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

      </div>
    </>
  );
};

export default MyLearning;
